import React from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import cx from 'classnames';
import pagination from '@culture/common-helpers/pagination';

import NextLink from 'components/NextLink';

import styles from './styles.module.scss';

const Pagination = ({ total, current }) => {
	const pages = pagination(current, total);
	const { query, pathname } = useRouter();

	return (
		<div className={styles.pagination}>
			{pages.map((page) =>
				page ? (
					<NextLink
						next
						key={page}
						href={{ pathname, query: { ...query, page } }}
						className={cx(styles.item, {
							[styles.active]: page === current
						})}
						ariaLabel={`Страница ${page}`}
					>
						{page}
					</NextLink>
				) : (
					<div className={styles.dots} key={page}>
						<div className={styles.dot} />
						<div className={styles.dot} />
						<div className={styles.dot} />
					</div>
				)
			)}
		</div>
	);
};

Pagination.propTypes = {
	total: PropTypes.number.isRequired,
	current: PropTypes.number.isRequired
};

export default Pagination;
